import { UserOutlined, UnlockOutlined } from "@ant-design/icons";
import _ from "lodash";
import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { ReactComponent as LOGO_LOGIN } from "@assets/svgs/LOGO_LOGIN.svg";
import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { setImportant } from "@redux/reducers/important.reducers";
import { COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";
import { initialMenuList } from "@utils/initialMenuList";
import {
  setLocalStorageAuth,
  setLocalStorageUserProfile,
} from "@utils/localStorage";
import { VALIDATE_RULES } from "@validate/index";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
`;

const SectionLogin = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: center; */
  flex-direction: column;
  width: 536px;
  /* height: 396px; */
  padding: 44px 68px;
  gap: 24px;
`;

export default () => {
  const { control, handleSubmit } = useForm();

  const disPatch = useDispatch();
  const navigate = useNavigate();

  const onHandleLogin = async (data) => {
    const username = _.get(data, ["username"]);
    const password = _.get(data, ["password"]);

    const resp = await fetchAPI({
      method: "post",
      path: "/auth/login",
      data: { username, password },
    });
    if (_.get(resp, ["status"])) {
      const userProfile = _.get(resp, ["result", "userProfile"]);
      const authToken = _.get(resp, ["result", "authToken", "token"]);
      const userPermission = _.get(userProfile, ["role", "permissions"]);
      setLocalStorageAuth({ authToken });
      setLocalStorageUserProfile({ userProfile });
      const initialMenu = initialMenuList({
        userPermission,
      });
      disPatch(
        setImportant({
          initialMenu: _.get(initialMenu, ["menuList"]),
          defaultLocation: _.get(initialMenu, ["defaultLocation"]),
        })
      );
      const redirectLocation = _.get(initialMenu, ["defaultLocation"]);
      navigate(redirectLocation);
    }
  };

  return (
    <Container>
      <SectionLogin>
        <Icon width={"224px"} height={"88px"}>
          <LOGO_LOGIN />
        </Icon>
        <form
          autoComplete="off"
          onSubmit={handleSubmit(onHandleLogin)}
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: 4,
          }}
        >
          <Controller
            name="username"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <>
                <StyledInput
                  {...field}
                  size="large"
                  placeholder="Username"
                  prefix={<UserOutlined />}
                />
                <ErrorValidate error={error} />
              </>
            )}
          />
          <Controller
            name="password"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <>
                <StyledInput
                  {...field}
                  type="password"
                  size="large"
                  placeholder="Password"
                  prefix={<UnlockOutlined />}
                />
                <ErrorValidate error={error} />
              </>
            )}
          />
          <Button
            type="submit"
            border="8px"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="7px 0px"
            width="100%"
            height="40px"
          >
            Login
          </Button>
        </form>
      </SectionLogin>
    </Container>
  );
};
